import app from 'flarum/forum/app';
import Discussion from 'flarum/common/models/Discussion';
import { ModelIdentifier } from 'flarum/common/Model';
import Post from 'flarum/common/models/Post';

const key = 'commentTreeSortType';

export function isCreatedAtDesc() {
  const setting = app.session.user?.preferences()[key] || app.forum.attribute(key);
  return setting === '-createdAt';
}

export function isCreatedAtAsc() {
  const setting = app.session.user?.preferences()[key] || app.forum.attribute(key);
  return !setting || setting === 'createdAt';
}

export function sortPostIdentifiers(data: ModelIdentifier[], type: 'asc' | 'desc') {
  data.sort((a, b) => {
    const postA = app.store.getById<Post>('posts', a.id);
    const postB = app.store.getById<Post>('posts', b.id);
    if (!postA || !postB) return 0;
    if (type === 'asc') {
      return postA.number() - postB.number();
    } else {
      return postB.number() - postA.number();
    }
  });
  if (type === 'desc' && data.length) {
    const oldest = data[data.length - 1];
    const post = app.store.getById<Post>('posts', oldest.id);
    if (post?.number() === 1) {
      data.pop();
      data.unshift(oldest);
    }
  }
}

export function sortPostMentioned(post: Post, type: 'asc' | 'desc') {
  const mentionedBy = post.data.relationships?.['mentionedBy']?.data;

  if (Array.isArray(mentionedBy)) {
    sortPostIdentifiers(mentionedBy, type);
  }
}

export function sortDiscussionPost(discussion: Discussion, type: 'asc' | 'desc') {
  const posts = discussion.data.relationships?.['posts']?.data;
  const treeTopPosts = discussion.data.relationships?.['treeTopPosts']?.data;

  if (Array.isArray(posts)) {
    sortPostIdentifiers(posts, type);
    posts.forEach((item) => {
      const post = app.store.getById<Post>('posts', item.id);
      if (!post) return;
      sortPostMentioned(post, type);
    });
  }
  if (Array.isArray(treeTopPosts)) {
    sortPostIdentifiers(treeTopPosts, type);
  }
}
